import { render, staticRenderFns } from "./ProofPeriodDialogSelector.vue?vue&type=template&id=0b1ce201&scoped=true&"
import script from "./ProofPeriodDialogSelector.vue?vue&type=script&lang=ts&"
export * from "./ProofPeriodDialogSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ProofPeriodDialogSelector.vue?vue&type=style&index=0&id=0b1ce201&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1ce201",
  null
  
)

export default component.exports